import declare from "dojo/_base/declare";
import CopyShapeController from "./CopyShapeController";


const SiteViewCopyShapeController = declare(CopyShapeController, {
	/**@override */
	idOwnerRelation: "Shapes",

});

export = SiteViewCopyShapeController;


